export const filters = {
    clear: ['очистить', 'clear'],
    filter: ['фильтр', 'filter'],
    noCode: ['Нет кода', 'No code'],
    noSelectData: ['Нет выбранных данных', 'No Select Data'],
    noSsr: ['Нет SSR', 'No SSR'],
    noSsrType: ['Нет вида SSR', 'No SSR Type'],
    passengerType: ['Вид пассажиров', 'Passenger type'],
    selectAll: ['Выбрать все', 'Select All'],
    ssr: ['SSR', 'SSR'],
    ssrType: ['Вид SSR', 'SSR type'],
};
